import { OmnibarEntry } from '../omnibar-interfaces';

export type OmnibarOpensIn = 'sameTab' | 'newWindow' | 'dialog';

export function entryOpensIn(entry: OmnibarEntry): OmnibarOpensIn {
  if (entry.opensIn) return entry.opensIn;
  if (entry.url) return 'sameTab';
  if (entry.dynamicLinksAction || entry.getModalControl) return 'dialog';
  return 'newWindow';
}
